import './App.css';
import Chatroom from "./pages/chatroom";
import Landing from './pages/landing';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './pages/about';
import History from './pages/history';

function App() {

  return (
        <Router>
          <Routes>
            <Route path="/" element={<Landing/>} />
            <Route path="/home" element={<Landing/>} />
            <Route path="/chat/:id" element={<Chatroom/>} />
            <Route path="/about-us" element={<About/>} />
            <Route path="/our-purpose" element={<History/>} />

          </Routes>
        </Router>
  );
}

export default App;